type UrlOnlyRewriteRouterState = {
    preventScrollReset: true;
    skipRouteDataLoad: true;
};

/**
 * Router state for a `replace` navigation that only rewrites the URL of what the page already shows:
 * `RouteDataLoader` doesn't refetch it and `ScrollMemory` doesn't scroll to the top.
 */
export const urlOnlyRewriteRouterState: UrlOnlyRewriteRouterState = {
    preventScrollReset: true,
    skipRouteDataLoad: true,
};

export const isUrlOnlyRewriteRouterState = (state: unknown): state is UrlOnlyRewriteRouterState =>
    typeof state === 'object' &&
    state !== null &&
    !Array.isArray(state) &&
    (state as Record<string, unknown>).skipRouteDataLoad === true;
